// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { createSlice } from '@reduxjs/toolkit';
import { CreateImageryRequestFailedAction, CreateImageryRequestStartAction, CreateImageryRequestSuccessAction, GetImageryCoverageFailedAction, GetImageryCoverageStartAction, GetImageryCoverageSuccessAction, GetImageryProvidersFailedAction, GetImageryProvidersStartAction, GetImageryProvidersSuccessAction, ResetImageryCoverageAction, SetHorizontalEpsgAction, SetImageryCheckedAction, SetVerticalEpsgAction, ToggleImageryProcessingAction } from './imageryActions';

const initialState: IImageryState = {
  loading: false,
  imageryProviders: [],
  coverageLoading: false,
  vendors: [],
  anyCoverage: null,
  winnerVendor: null,
  imageryChecked: false,
  imageryProcessing: true,
  createImageryLoading: false,
  horizontalEpsg: '',
  verticalEpsg: '',
};

const imagerySlice = createSlice({
  name: 'imagery',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetImageryProvidersStartAction, (state) => {
        state.loading = true;
      })
      .addCase(GetImageryProvidersSuccessAction, (state, action) => {
        state.loading = false;
        state.imageryProviders = action.payload;
      })
      .addCase(GetImageryProvidersFailedAction, (state) => {
        state.loading = false;
      })
      .addCase(GetImageryCoverageStartAction, (state) => {
        state.coverageLoading = true;
        state.vendors = [];
        state.anyCoverage = null;
        state.winnerVendor = null;
      })
      .addCase(GetImageryCoverageSuccessAction, (state, action) => {
        state.coverageLoading = false;
        state.vendors = action.payload.vendors;
        state.anyCoverage = action.payload.coverage;
        state.winnerVendor = action.payload.winnerVendor;
      })
      .addCase(GetImageryCoverageFailedAction, (state) => {
        // check-failed is not "no coverage": anyCoverage stays null so the UI can distinguish
        state.coverageLoading = false;
        state.vendors = [];
        state.anyCoverage = null;
        state.winnerVendor = null;
      })
      .addCase(ResetImageryCoverageAction, (state) => {
        state.coverageLoading = false;
        state.vendors = [];
        state.anyCoverage = null;
        state.winnerVendor = null;
        state.imageryChecked = false;
      })
      .addCase(SetImageryCheckedAction, (state, action) => {
        state.imageryChecked = action.payload;
      })
      .addCase(ToggleImageryProcessingAction, (state) => {
        state.imageryProcessing = !state.imageryProcessing;
      })
      .addCase(SetHorizontalEpsgAction, (state, action) => {
        state.horizontalEpsg = action.payload;
      })
      .addCase(SetVerticalEpsgAction, (state, action) => {
        state.verticalEpsg = action.payload;
      })
      .addCase(CreateImageryRequestStartAction, (state) => {
        state.createImageryLoading = true;
      })
      .addCase(CreateImageryRequestSuccessAction, (state) => {
        state.createImageryLoading = false;
        state.imageryProcessing = true;
        state.horizontalEpsg = '';
        state.verticalEpsg = '';
      })
      .addCase(CreateImageryRequestFailedAction, (state) => {
        state.createImageryLoading = false;
        state.imageryProcessing = true;
      });
  },
});

export const { reducer } = imagerySlice;

export default reducer;
